'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import NProgress from 'nprogress';

// Configure NProgress: no spinner (we use the top bar only), fast trickle
NProgress.configure({ showSpinner: false, trickleSpeed: 200, minimum: 0.1 });

/**
 * Shows a thin progress bar at the top of the viewport during route transitions.
 * Listens for pathname/searchParams changes to start/complete the bar.
 */
export function NavigationProgress() {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        NProgress.done();
    }, [pathname, searchParams]);

    // Start NProgress on click of internal links
    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            const anchor = (e.target as HTMLElement).closest('a');
            if (!anchor) return;
            const href = anchor.getAttribute('href');
            if (!href || href.startsWith('http') || href.startsWith('#') || href.startsWith('mailto:')) return;
            if (anchor.target === '_blank') return;
            // Don't start if navigating to the same page
            if (href === pathname) return;
            NProgress.start();
        };

        document.addEventListener('click', handleClick);
        return () => document.removeEventListener('click', handleClick);
    }, [pathname]);

    return null;
}
